// pages/+Page.tsx
import { lazy, Suspense } from "react";
import LoadingComponent from "@fableous/ui/components/layout/LoadingComponent";
import OpenRoute from "@fableous/ui/components/routes/OpenRoute";
const ArtStyles = lazy(() => import("@fableous/ui/containers/marketing/ArtStyles"));

function Page() {
    return (
        <Suspense fallback={<LoadingComponent />}>
            <OpenRoute>
                <ArtStyles />
            </OpenRoute>
        </Suspense>
    );
}

export { Page };
